<template>
  <b-modal id="newWidgetModal" size="lg" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" @show="clearData()" @hide="closeModal()">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fas', 'marker']" size="1x" class="mr-2"/> New widget </h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default" slot-scope="{ close }">
      <b-form-group id="input-group-0" label="Widget Component" label-for="input-0">
        <b-form-select v-model="newWidget.name" >
          <b-form-select-option  v-for="widget in widgetComponents" :key="widget.name" :value="widget.value">{{t(widget.name, widget.name)}}</b-form-select-option>
        </b-form-select>
      </b-form-group>
      <b-form-group id="input-group-2" label="Widget Translation Key" label-for="input-2">
        <b-form-input id="input-2" v-model="newWidget.translationKey" type="text" required placeholder="Widget Translation Key"></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-3" label="Widget Translation Label" label-for="input-3">
        <b-form-input id="input-3" v-model="newWidget.translation" type="text" required placeholder="Widget Translation"></b-form-input>
      </b-form-group>
      <div class="col-12 text-left mb-2 px-0">Widget Permissions</div>
      <div class="col-12 px-0" v-if="userLevels">
        <table class="table b-table table-striped table-hover table-bordered">
          <thead class="brand-color">
          <tr>
            <th v-for="level in userLevels" :key="level.id">{{ level.name }}</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td v-for="level in userLevels" :key="level.id">
              <b-form-checkbox v-model="newWidget.permissions[level.id]"></b-form-checkbox>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel, close }">
      <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
        <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/> Close
      </button>
      <button aria-label="AcceptAllDocs" data-dismiss="modal" class="btn btn-primary" type="button" @click="createNewWidget()" :disabled="isCreateNewWidgetDisabled">
        <fontAwesomeIcon :icon="['fa', 'thumbs-up']" class="text-light mr-2"/> Create Widget
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalWidgetConfiguration',
  props: ['userLevels', 'widgetComponents'],
  components:{
  },
  computed:{
   isCreateNewWidgetDisabled() {
     return this.newWidget.name == ''
         || this.newWidget.translation == ''
         || this.newWidget.translationKey == '';
   }
  },
  data() {
    return {
      newWidget: {
        translationKey: '',
        translation: '',
        name: '',
        permissions: []
      },
    }
  },
  methods: {
    clearData() {
      this.newWidget =
        {
          translationKey: '',
          translation: '',
          name: '',
          permissions: []
        }
    },
    closeModal() {
      this.$parent.closeNewWidgetModal()
    },
    createNewWidget() {
      this.$store.dispatch('alertClearResponse')
      this.$store.dispatch('widgetsStore/createNewWidget', this.newWidget).then(response => {
        if(response.status && response.status == 'success') {
          this.closeModal()
          this.$parent.getWidgetsPermissions()
        }
      })
    }
  },
}
</script>

<style scoped>

</style>
